import React from "react";
import about3 from "../assets/Images/about3.jpg";
import about4 from "../assets/Images/about4.jpg";
import team from "../assets/Images/team.JPG";
import img55 from "../assets/Images/img55.png";
const About = () => {
  return (
    <div>
      {/* new about section start */}




      <section id="about" className="about section" style={{ padding: "60px 0" }}>
        <div className="container">

          {/* Top Row */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 mb-md-5">

            {/* Left */}
            <div style={{ maxWidth: "570px", width: "100%" }}>
              <button
                style={{
                  border: "1.5px solid #e0e0e0",
                  borderRadius: "20px",
                  padding: "6px 18px", // thoda padding bhi badhaya
                  fontSize: "14px", // size increase
                  fontWeight: "500", // readability better
                  background: "#fff",
                  color: "#494949",
                  marginBottom: "14px",
                  whiteSpace: "nowrap",
                }}
              >
                About Visko Group
              </button>

              <p style={{
                fontSize: "clamp(14px, 2vw, 18px)",
                fontWeight: "400",
                lineHeight: "1.55",
                color: "#222",
                margin: 0,
              }}>
                The Visko Group brings together four distinct ventures, including HR, Food,
                Realty, Textiles, and E-Serve, each driven by a shared vision to innovate,
                create meaningful impact, and redefine industries for the future.
              </p>
            </div>

            {/* Right - 10+ Years */}
            <div className="mt-3 mt-md-0" style={{ flexShrink: 0 }}>
              <div style={{ display: "inline-block", textAlign: "left" }}>
                <h2
                  style={{
                    fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                    fontWeight: "900",
                    color: "#111",
                    marginBottom: "5px",
                    lineHeight: "1",
                    letterSpacing: "-1px",
                  }}
                >
                  10+
                </h2>
                <p
                  style={{
                    fontSize: "clamp(11px, 1.5vw, 13px)",
                    fontWeight: "500",
                    color: "#888",
                    margin: "4px 0 0 0",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                  }}
                >
                  Years Experience
                </p>
              </div>
            </div>

          </div>

          {/* Bottom Row */}
          <div className="row align-items-center g-4">

            {/* Left Image */}
            <div className="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-start">
              <img
                src={img55}
                alt=""
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  height: "clamp(200px, 30vw, 290px)",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>

            {/* Right Content */}
            <div className="col-12 col-lg-7">

              {/* Logos */}
              <div className="d-flex align-items-center flex-wrap mb-3 gap-2">
                {[
                  {
                    img: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1775212108_46bc8467f89c0cebadc9.png",
                    link: "https://viskoeserve.in/",
                  },
                  {
                    img: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1775212118_7f6c8309ba534812b938.png",
                    link: "https://viskohr.com/",
                  },
                  {
                    img: "https://api.visko.group/public/assets/img/uploads/ticket-docs/1767079710_638b89f1e84599189d51.webp",
                    link: "https://viskorealestate.ae/"

                  },
                ].map((item, i) => (
                  <a
                    key={i}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={item.img}
                      alt="project logo"
                      style={{
                        width: "clamp(40px, 6vw, 50px)",
                        height: "clamp(40px, 6vw, 50px)",
                        borderRadius: "50%",
                        objectFit: "contain",
                        backgroundColor: "#f5f5f5",
                        padding: "6px",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                ))}
              </div>

              {/* Description */}
              <p style={{
                fontSize: "clamp(13px, 2vw, 16px)",
                lineHeight: "1.75",
                color: "#555",
                marginBottom: 0,
              }}>
                At Visko Group, we believe in innovation, resilience, and creating future opportunities.
                What began as a vision has grown into a dynamic company across HR solutions, real estate,
                textile, and digital services, driven by technology and excellence.<br /><br />
                Visko Group's journey reflects passion, perseverance, and innovation.
                Founded by Shalini Vishwakarma and Akshay Korgaonkar, it has grown from a startup into a multi-faceted business.
                Starting with Job Hub in 2016, it evolved into Visko HR Pvt. Ltd. in 2020, offering AI-driven recruitment solutions.
                In 2021, the Group expanded into real estate with fractional ownership,
                making property investment more accessible.
              </p>

            </div>
          </div>
        </div>
      </section>

      <section id="about" class="about section mb-0">
        <div class="container">
          <div class="row gy-4">
            <div class="container section-title" data-aos="fade-up">
              <h2>Meet Our Visionary Leaders</h2>
            </div>
            <div className="container py-5">
              <div className="row align-items-center mb-5">
                <div className="col-lg-3 col-2xl-2 col-12 mb-3 mb-md-0 d-flex justify-content-center">
                  <div
                    style={{
                      width: "200px",
                      height: "200px",

                      borderRadius: "10px",
                    }}
                  >
                    <img
                      style={{
                        height: "200px",
                        width: "200px",
                        borderRadius: "10px",
                        objectFit: "cover",
                      }}
                      src="https://api.visko.group/public/assets/img/uploads/ticket-docs/1774958274_46f1dcfda67d7075a0b7.png"
                    />
                  </div>
                </div>
                <div className="col-lg-9  col-2xl-10  col-12">
                  <h5 className="fw-bold">Shalini Vishwakarma</h5>
                  <p className="mb-0 text-muted  text-start">
                    A dynamic leader with expertise in marketing and finance,
                    Shalini brings over six years of experience working with top
                    companies like HDFC, ICICI, and Reliance. Her strategic
                    insights and deep understanding of market trends have played
                    a crucial role in Visko Group’s success. She firmly believes
                    that the key to growth lies in networking, innovation, and
                    smart marketing strategies. Beyond her corporate
                    achievements, Shalini is passionate about empowering
                    aspiring entrepreneurs and mentoring them to navigate the
                    competitive business landscape. Her leadership style is
                    rooted in collaboration, creativity, and a commitment to
                    excellence.
                  </p>
                </div>
              </div>

              <div className="row align-items-center flex-md-row-reverse">
                <div className="col-lg-3 col-2xl-2 col-12 mb-3 mb-md-0 d-flex justify-content-center">
                  <div
                    style={{
                      width: "200px",
                      height: "200px",

                      borderRadius: "10px",
                    }}
                  >
                    <img
                      style={{
                        height: "200px",
                        width: "200px",
                        borderRadius: "10px",
                        objectFit: "cover",
                      }}
                      src="https://api.visko.group/public/assets/img/uploads/ticket-docs/1775131824_ce9c8335aab6de250fcf.png"
                    />
                  </div>
                </div>
                <div className="col-lg-9 col-2xl-10 col-12">
                  <h5 className="fw-bold text-lg-end text-start">
                    Akshay Korgaonkar
                  </h5>
                  <p className="mb-0 text-muted  text-start">
                    With a background in Electronics & Telecommunication
                    Engineering and an MBA in Business, Akshay has an extensive
                    career in commodity markets, risk management, and equity
                    trading. His entrepreneurial mindset and passion for
                    innovation have been instrumental in expanding Visko Group
                    into multiple industries, ensuring it remains at the
                    forefront of business excellence. Akshay's ability to
                    identify emerging market trends and capitalize on them has
                    made him a visionary leader in the corporate world. He
                    thrives on strategic planning, disruptive thinking, and
                    fostering a work culture that encourages continuous learning
                    and adaptability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" class="about section mb-0">
        <div class="container">
          <div class="row gy-4">
            <div class="container section-title" data-aos="fade-up">
              <h2> Our Strength – The Visko Team</h2>
            </div>
            <div
              class="col-lg-6 pt-3 "
              data-aos="fade-up"
              data-aos-delay="100"
              style={{ alignItems: "center" }}
            >
              <p
                className=" fs-sm-2 fs-md-6"
                style={{
                  marginBottom: "8px",
                }}
              >
                Behind our success is a team of 50+ skilled professionals
                dedicated to driving growth and innovation. We believe in the
                power of collaboration and expertise, ensuring that each
                department functions seamlessly, from technology development to
                strategic marketing.
              </p>
              <p
                className=" fs-sm-2 fs-md-6"
                style={{
                  marginBottom: "8px",
                }}
              >
                At Visko Group, our mission is simple - Innovate | Empower |
                Grow. We aim to provide cutting-edge solutions that cater to job
                seekers, businesses, and investors, making a lasting impact on
                their success stories.
              </p>
              <p
                className=" fs-sm-2 fs-md-6"
                style={{
                  marginBottom: "8px",
                }}
              >
                As we continue to grow, we invite you to be a part of our story.
                Whether you’re looking for career opportunities, business
                partnerships, or investment possibilities - Visko Group is here
                to turn your aspirations into reality.
              </p>
              <p class=" fw-semibold">
                Our vision is to expand our operations across 15 states in India
                within the next few years, making Visko Group a name synonymous
                with trust, innovation, and excellence.
              </p>
              <p class="fw-bold">
                Let’s innovate, inspire, and achieve greatness together!
              </p>
            </div>
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="250">
              <div class="content ps-0 ps-lg-5">
                <div class="position-relative mt-2 ">
                  <img
                    src={team}
                    class="img-fluid rounded-4"
                    alt=""
                    style={{ borderRadius: "5px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* new about section end */}
      <section id="pricing" class="pricing section ">
        <div class="container">
          <div class="row gy-4 d-flex justify-content-center">
            <div
              class="col-lg-6 col-md-6"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div class="pricing-item">

                <h5>
                  <strong className="text-danger fs-3">
                    Proven Industry <br></br>Experience
                  </strong>
                </h5>
                <p style={{ marginTop: '2rem' }}>
                  With over 5 years of hands-on experience, we operate across multiple industries, delivering practical,
                  scalable solutions built on deep domain knowledge and real-world execution.

                </p>
              </div>
            </div>

            <div
              class="col-lg-6 col-md-6"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div class="pricing-item">


                <h5>
                  <strong className="text-danger fs-3">
                    50+ Skilled Professionals<br></br> Driving Growth

                  </strong>
                </h5>
                <p style={{ marginTop: '2rem' }}>
                  A team of 50+ experienced professionals working across diverse domains, combining strategy,
                  innovation, and execution to drive consistent business growth.

                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
